import { createContext, useContext } from "react";
import type { components } from "@dolfin/api-admin";

/** The signed-in demo organisation's seeding state and expiry, from GET /organisations/{id}. */
export interface DemoState {
  status: NonNullable<components["schemas"]["DemoStatus"]>;
  expiresAt: string | null;
}

/**
 * `demo` is the banner's state, null until read (or when the org isn't a demo). `isDemo` gates writes and comes from
 * the session's client type, so it never waits on a request and never fails open.
 */
export const DemoContext = createContext<{ demo: DemoState | null; isDemo: boolean; refresh: () => void }>({
  demo: null,
  isDemo: false,
  refresh: () => undefined,
});

export function useDemo() {
  return useContext(DemoContext);
}

/**
 * True in a demo organisation (spec "AD - Demo Organisations", D7): writes outside the server's allowlist are hidden
 * or disabled. The server answers them 403 Demo.ReadOnly anyway; this only keeps the controls honest.
 */
export function useIsDemo() {
  return useContext(DemoContext).isDemo;
}
